const WpCheckToggle = (() => {
    const buttonSelector = '[data-wp-toggle~="checktoggle"]';
    const defaultInitialState = 'checked';

    const getButtons = (context = document) => {
        if (context.matches && context.matches(buttonSelector)) {
            return [context];
        }

        return Array.from(context.querySelectorAll(buttonSelector));
    };

    const getTargetSelector = (button) => {
        return button.dataset.checktoggleTarget || '';
    };

    const getTargetScope = (button) => {
        return button.closest('form') || document;
    };

    const getCheckboxes = (button) => {
        const targetSelector = getTargetSelector(button);
        if (!targetSelector) {
            return [];
        }

        return Array.from(getTargetScope(button).querySelectorAll(targetSelector)).filter((checkbox) => {
            return checkbox.matches('input[type="checkbox"]') && !checkbox.disabled;
        });
    };

    const getBaseText = (button) => {
        if (!button.dataset.checktoggleBaseText) {
            button.dataset.checktoggleBaseText = button.textContent.trim();
        }

        return button.dataset.checktoggleBaseText;
    };

    const getAlternateText = (button) => {
        return button.dataset.checktoggleText || '';
    };

    const getInitialState = (button) => {
        return button.dataset.checktoggleInitial === 'unchecked' ? 'unchecked' : defaultInitialState;
    };

    const areAllChecked = (checkboxes) => {
        return checkboxes.length > 0 && checkboxes.every((checkbox) => checkbox.checked);
    };

    const updateButtonText = (button) => {
        const checkboxes = getCheckboxes(button);
        if (!checkboxes.length) {
            return;
        }

        const baseText = getBaseText(button);
        const alternateText = getAlternateText(button);
        const initialState = getInitialState(button);
        const isCheckedState = areAllChecked(checkboxes);
        const shouldUseBaseText = (initialState === 'checked' && isCheckedState)
            || (initialState === 'unchecked' && !isCheckedState);

        button.textContent = shouldUseBaseText ? baseText : alternateText || baseText;
    };

    const toggleCheckboxes = (button) => {
        const checkboxes = getCheckboxes(button);
        if (!checkboxes.length) {
            return;
        }

        const shouldCheck = !areAllChecked(checkboxes);

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked === shouldCheck) {
                return;
            }

            checkbox.checked = shouldCheck;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });

        updateButtonText(button);
    };

    const sync = (context = document) => {
        getButtons(context).forEach((button) => {
            updateButtonText(button);
        });
    };

    const handleClick = (event) => {
        const button = event.target.closest(buttonSelector);
        if (!button) return;

        event.preventDefault();
        toggleCheckboxes(button);
    };

    const handleChange = (event) => {
        const checkbox = event.target.closest('input[type="checkbox"]');
        if (!checkbox) return;

        getButtons(document).forEach((button) => {
            const checkboxes = getCheckboxes(button);
            if (checkboxes.includes(checkbox)) {
                updateButtonText(button);
            }
        });
    };

    const init = () => {
        document.addEventListener('click', handleClick);
        document.addEventListener('change', handleChange);
        sync();
    };

    return { init, sync };
})();

window.WpCheckToggle = WpCheckToggle;
WpCheckToggle.init();
